module.exports = __webpack_public_path__ + "static/img/instagram.527bc41a.svg";